module.exports = __webpack_public_path__ + "static/media/20240227114131_IMG_5528.0747d8c9.JPG";